<!--
*
* ©2018    <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: flex-start; align-items: stretch; gap: 10px">
<div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: flex-start; align-items: stretch; gap: 10px; flex: 1 1 0 1 calc(33.333% - 10px)%; max-width: 0 1 calc(33.333% - 10px)%; box-sizing: border-box" class="app-container" *ngFor="let app of appList;let i = index" (click)="goToApp(app)".xs="0 1 calc(50% - 10px)".sm="0 1 calc(33.333% - 10px)">div>
  <div style="flex: 1 1 0 1 calc(33.333% - 10px)%; max-width: 0 1 calc(33.333% - 10px)%; box-sizing: border-box" class="app-container" *ngFor="let app of appList;let i = index" (click)="goToApp(app)".xs="0 1 calc(50% - 10px)".sm="0 1 calc(33.333% - 10px)">geVerve Systems Limited, Bangalore, India. All Rights Reserved.
    *
    * The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
    * and other pending or existing intellectual property rights in India, the United States and other countries. The Program
    * may contain / reference third party or open source components, the rights to which continue to remain with the applicable
    * third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
    * and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
    * form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or
    * otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
    * prosecuted to the maximum extent possible under the law.
    *
    -->
    <div class="app-switcher-ui np0">
      <div class="app-grid-scroll">
        <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: flex-start; align-items: stretch;">
          @for (app of appList; track app; let i = $index) {
            <div class="app-container"  [class.light-blue-bg]="app.appName?.toLowerCase() === 'p2i sourcing and contracts'" (click)="goToApp(app)">
              <div style="justify-content: center; align-items: center">
                <mat-icon class="icon-holder" [ngClass]="getClass(i)">{{app.appIcon}}</mat-icon>
              </div>
              <div class="app-text"  title="{{app.appName}}">{{app.appName}}</div>
            </div>
          }
        </div>
      </div>
    </div>

